const logCodes: { [key: number]: { label: string, type: 'normal' | 'warning' | 'error' } } = {
  0:   { label: 'System',              type: 'normal' },
  1:   { label: 'General',             type: 'normal' },
  2:   { label: 'Error',               type: 'error' },
  3:   { label: 'Debug',               type: 'normal' },
  4:   { label: 'Extlog',              type: 'normal' },
  5:   { label: 'EVSE log',            type: 'normal' },
  6:   { label: 'Warning',             type: 'warning' },
  7:   { label: 'chg.stat',            type: 'normal' },
  8:   { label: 'restart',             type: 'normal' },
  9:   { label: 'ocpp',                type: 'normal' },
  10:  { label: 'daily1',              type: 'normal' },
  11:  { label: 'command',             type: 'normal' },
  12:  { label: 'PS',                  type: 'normal' },
  13:  { label: 'FirstRun',            type: 'normal' },
  14:  { label: 'journal',             type: 'normal' },
  15:  { label: 'InitDone',            type: 'normal' },
  16:  { label: 'WDG',                 type: 'normal' },
  17:  { label: 'OSUpgr.',             type: 'normal' },
  18:  { label: 'Pi2PiCli',            type: 'normal' },
  19:  { label: 'Pi2PiMa',             type: 'normal' },
  20:  { label: 'upgr.sta',            type: 'normal' },
  21:  { label: 'evse',                type: 'normal' },
  22:  { label: 'MID_24h',             type: 'normal' },
  23:  { label: 'PCB OK',              type: 'normal' },
  24:  { label: 'PCB fail',            type: 'normal' },
  25:  { label: 'PPRFID',              type: 'normal' },
  26:  { label: 'EVSE warn',           type: 'warning' },
  27:  { label: 'EVSE err',            type: 'error' },
  28:  { label: 'EVSE com',            type: 'error' },
  29:  { label: 'EVSE com',            type: 'warning' },
  30:  { label: 'network',             type: 'normal' },
  31:  { label: 'GSM',                 type: 'normal' },
  32:  { label: 'websock',             type: 'normal' },
  101: { label: 'LTD_EVSE_FLAGS',      type: 'error' },
  102: { label: 'LTD_SOFT_RESET_ERR',  type: 'error' },
  103: { label: 'LTD_EXT_WDG_RESET',   type: 'error' },
}

export function getLogCodeLabel(code: number): string {
  return logCodes[code]?.label || `Code: ${code}`
}

export function getLogCodeType(code: number): 'normal' | 'warning' | 'error' {
  if (code >= 100) return 'error'
  return logCodes[code]?.type || 'normal'
}

export function getLogCodesByType(...types: ('normal' | 'warning' | 'error')[]): number[] {
  return Object.entries(logCodes).filter(([, v]) => types.includes(v.type)).map(([k]) => Number(k))
}

export default logCodes
